"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBXsU9PJPGdHkA5xZcxCesE1997133026Screen = ModalBXsU9PJPGdHkA5xZcxCesE1997133026Screen;
var _materialSymbols = require("@design/icons/material-symbols");
var _avatar = require("@design/ui/avatar");
var _button = require("@design/ui/button");
var _input = require("@design/ui/input");
var _kbd = require("@design/ui/kbd");
var _modalBXsU9PJPGdHkA5xZcxCesE = require("./modal-bXsU9PJPGdHkA5xZcxCesE-1997-133026.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ModalBXsU9PJPGdHkA5xZcxCesE1997133026Screen() {
  var _w$modalHeaderContent, _w$modalContent, _w$selectShowIcon, _w$selectPlaceholder, _w$avatarGroupSlot, _w$avatarFallbackText, _w$avatarShowBadge, _w$modalActionsSlot, _w$buttonShowIconStar, _w$buttonLabel, _w$buttonShowKbd, _w$kbdShowLeftIcon, _w$kbdLabel, _w$kbdShowRightIcon, _w$buttonShowIconEnd, _w$buttonShowIconStar2, _w$buttonLabel2, _w$buttonShowKbd2, _w$kbdShowLeftIcon2, _w$kbdLabel2, _w$kbdShowRightIcon2, _w$buttonShowIconEnd2;
  var w = (0, _modalBXsU9PJPGdHkA5xZcxCesE.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      width: "600px",
      maxWidth: "800px",
      maxHeight: "800px",
      backgroundColor: "rgba(253, 253, 252, 1)",
      borderRadius: "8px"
    },
    "data-sentry-component": "ModalBXsU9PJPGdHkA5xZcxCesE1997133026Screen",
    "data-sentry-source-file": "modal-bXsU9PJPGdHkA5xZcxCesE-1997-133026.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        gap: "16px",
        alignItems: "flex-start",
        padding: "16px 16px 0px 16px",
        alignSelf: "stretch"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          alignItems: "flex-start",
          flexGrow: "1",
          flexBasis: "0",
          minWidth: "0"
        },
        children: (_w$modalHeaderContent = w.modalHeaderContent) !== null && _w$modalHeaderContent !== void 0 ? _w$modalHeaderContent : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              alignSelf: "stretch",
              color: "rgba(28, 25, 23, 1)",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px"
            },
            children: "Share “Workspace Name”"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              alignSelf: "stretch",
              color: "rgba(142, 138, 131, 1)",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px"
            },
            children: "Invite collaborators to this workspace. They will have access to all its artifacts and flows. Your chats remain private."
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, _objectSpread(_objectSpread({}, w.close), {}, {
        "data-sentry-element": "CloseIcon",
        "data-sentry-source-file": "modal-bXsU9PJPGdHkA5xZcxCesE-1997-133026.tsx"
      }))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "32px",
        alignItems: "flex-start",
        padding: "24px 24px 24px 24px",
        alignSelf: "stretch",
        overflowY: "auto"
      },
      children: (_w$modalContent = w.modalContent) !== null && _w$modalContent !== void 0 ? _w$modalContent : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            alignItems: "flex-start",
            alignSelf: "stretch"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "flex-start",
              alignSelf: "stretch"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(63, 60, 56, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: "Invite an individual"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, _objectSpread(_objectSpread({}, w.input), {}, {
              type: "text",
              defaultValue: "Arno"
            }))]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "flex-start",
              alignSelf: "stretch"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(63, 60, 56, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: "Invite a team"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                display: "flex",
                flexDirection: "row",
                gap: "4px",
                alignItems: "center",
                padding: "8px 12px 8px 12px",
                alignSelf: "stretch",
                height: "40px",
                backgroundColor: "rgba(253, 253, 252, 1)",
                border: "1px solid rgba(142, 138, 131, 1)",
                borderRadius: "8px"
              },
              children: [((_w$selectShowIcon = w.selectShowIcon) !== null && _w$selectShowIcon !== void 0 ? _w$selectShowIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "16px",
                  maxWidth: "100%",
                  height: "16px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(217, 217, 217, 1)"
                    }
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })]
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  flexGrow: "1",
                  flexBasis: "0",
                  minWidth: "0",
                  height: "20px",
                  color: "rgba(28, 25, 23, 1)",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px"
                },
                children: (_w$selectPlaceholder = w.selectPlaceholder) !== null && _w$selectPlaceholder !== void 0 ? _w$selectPlaceholder : "Icertis SA Demo, Legal AI Center of Excellence, and 2 other teams"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "16px",
                  maxWidth: "100%",
                  height: "16px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, _objectSpread({}, w.iconCaretDown))
              })]
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            justifyContent: "center",
            alignItems: "flex-start",
            alignSelf: "stretch"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              color: "rgba(63, 60, 56, 1)",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "20px"
            },
            children: "Who has access"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              alignItems: "center",
              alignSelf: "stretch"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarGroup, _objectSpread(_objectSpread({}, w.avatarGroup), {}, {
              "data-size": "lg",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  gap: "-14px",
                  alignItems: "center"
                },
                children: (_w$avatarGroupSlot = w.avatarGroupSlot) !== null && _w$avatarGroupSlot !== void 0 ? _w$avatarGroupSlot : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_avatar.Avatar, _objectSpread(_objectSpread({}, w.avatar), {}, {
                    size: "default",
                    "data-variant": "fallback",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: "rgba(63, 60, 56, 1)",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        textAlign: "center"
                      },
                      children: (_w$avatarFallbackText = w.avatarFallbackText) !== null && _w$avatarFallbackText !== void 0 ? _w$avatarFallbackText : "YC"
                    }), ((_w$avatarShowBadge = w.avatarShowBadge) !== null && _w$avatarShowBadge !== void 0 ? _w$avatarShowBadge : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_avatar.AvatarBadge, _objectSpread(_objectSpread({}, w.avatarBadge), {}, {
                      "data-type": "color"
                    })) : null]
                  }))
                })
              })
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                flexGrow: "1",
                flexBasis: "0",
                minWidth: "0",
                color: "rgba(28, 25, 23, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px"
              },
              children: "Only you have access"
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        gap: "12px",
        alignItems: "flex-start",
        padding: "0px 16px 16px 16px",
        alignSelf: "stretch"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          gap: "12px",
          justifyContent: "flex-end",
          alignItems: "center",
          flexGrow: "1",
          flexBasis: "0",
          minWidth: "0"
        },
        children: (_w$modalActionsSlot = w.modalActionsSlot) !== null && _w$modalActionsSlot !== void 0 ? _w$modalActionsSlot : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button), {}, {
            variant: "outline",
            size: "default",
            children: [((_w$buttonShowIconStar = w.buttonShowIconStart) !== null && _w$buttonShowIconStar !== void 0 ? _w$buttonShowIconStar : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(28, 25, 23, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: (_w$buttonLabel = w.buttonLabel) !== null && _w$buttonLabel !== void 0 ? _w$buttonLabel : "Cancel"
            }), ((_w$buttonShowKbd = w.buttonShowKbd) !== null && _w$buttonShowKbd !== void 0 ? _w$buttonShowKbd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd), {}, {
              children: [((_w$kbdShowLeftIcon = w.kbdShowLeftIcon) !== null && _w$kbdShowLeftIcon !== void 0 ? _w$kbdShowLeftIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(142, 138, 131, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px",
                  textAlign: "center"
                },
                children: (_w$kbdLabel = w.kbdLabel) !== null && _w$kbdLabel !== void 0 ? _w$kbdLabel : "⌘"
              }), ((_w$kbdShowRightIcon = w.kbdShowRightIcon) !== null && _w$kbdShowRightIcon !== void 0 ? _w$kbdShowRightIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null]
            })) : null, ((_w$buttonShowIconEnd = w.buttonShowIconEnd) !== null && _w$buttonShowIconEnd !== void 0 ? _w$buttonShowIconEnd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null]
          })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button2), {}, {
            variant: "default",
            size: "default",
            children: [((_w$buttonShowIconStar2 = w.buttonShowIconStart2) !== null && _w$buttonShowIconStar2 !== void 0 ? _w$buttonShowIconStar2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(244, 246, 251, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: (_w$buttonLabel2 = w.buttonLabel2) !== null && _w$buttonLabel2 !== void 0 ? _w$buttonLabel2 : "Invite"
            }), ((_w$buttonShowKbd2 = w.buttonShowKbd2) !== null && _w$buttonShowKbd2 !== void 0 ? _w$buttonShowKbd2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd2), {}, {
              children: [((_w$kbdShowLeftIcon2 = w.kbdShowLeftIcon2) !== null && _w$kbdShowLeftIcon2 !== void 0 ? _w$kbdShowLeftIcon2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(142, 138, 131, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px",
                  textAlign: "center"
                },
                children: (_w$kbdLabel2 = w.kbdLabel2) !== null && _w$kbdLabel2 !== void 0 ? _w$kbdLabel2 : "⌘"
              }), ((_w$kbdShowRightIcon2 = w.kbdShowRightIcon2) !== null && _w$kbdShowRightIcon2 !== void 0 ? _w$kbdShowRightIcon2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "12px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null]
            })) : null, ((_w$buttonShowIconEnd2 = w.buttonShowIconEnd2) !== null && _w$buttonShowIconEnd2 !== void 0 ? _w$buttonShowIconEnd2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null]
          }))]
        })
      })
    })]
  });
}